import PropTypes from "prop-types";
import React, { Component } from "react";
import { Keyboard, StyleSheet, View, ViewPropTypes } from "react-native";
import OtpInput from "./OtpInput";

/* eslint-disable */

export default class OtpInputs extends Component {
  static propTypes = {
    containerStyles: ViewPropTypes.style,
    errorMessage: PropTypes.string,
    errorMessageContainerStyles: ViewPropTypes.style,
    errorMessageTextStyles: ViewPropTypes.style,
    focusedBorderColor: PropTypes.string,
    unfocusedBorderColor: PropTypes.string,
    handleChange: PropTypes.func.isRequired,
    inputContainerStyles: ViewPropTypes.style,
    inputStyles: ViewPropTypes.style,
    inputTextErrorColor: PropTypes.string,
    numberOfInputs: PropTypes.number.isRequired
  };

  static defaultProps = {
    handleChange: console.log,
    focusedBorderColor: "#0000ff",
    unFocusedBorderColor: "transparent",
    inputTextErrorColor: "#ff0000",
    numberOfInputs: 4
  };

  state = {
    inputsArray: [],
    loading: false,
    otpCode: []
  };

  maxIndex = this.props.numberOfInputs - 1;
  minIndex = 0;
  inputs = [];

  componentDidMount = () => {
    this._renderInputs();
  };

  componentWillReceiveProps = (newProps) => {
    if (
      newProps.otpTextFromSMS !== this.props.otpTextFromSMS &&
      !isNaN(newProps.otpTextFromSMS)
    ) {
      const otpCode = this.state.otpCode;
      const splittedArray = newProps.otpTextFromSMS.split("");

      for (let i = 0; i < splittedArray.length; i++) {
        otpCode[i] = splittedArray[i];
      }
      this.props.handleChange && this.props.handleChange(otpCode.join(""));
      this.setState({ otpCode, error: null });
      Keyboard.dismiss();
    }
  };

  _updateText = (text, index) => {
    if (text) {
      const otpCode = this.state.otpCode;

      const splittedArray = text.split("");
      if (splittedArray.length > 1) {
        if (splittedArray.length === 2) {
          otpCode[index] = splittedArray[1];
        } else {
          for (let i = 0; i < splittedArray.length; i++) {
            otpCode[i] = splittedArray[i];
          }
        }
      } else {
        otpCode[index] = text;
      }

      this.props.handleChange && this.props.handleChange(otpCode.join(""));
      this.setState({ otpCode, error: null });
      if (index === this.maxIndex) {
        return Keyboard.dismiss();
      }

      if (index >= this.minIndex && index < this.maxIndex) {
        this._focusInput(index + 1);
      }
    }
  };

  _handleBackspace = ({ nativeEvent }, index) => {
    if (nativeEvent.key === "Backspace") {
      const otpCode = this.state.otpCode;
      otpCode[index] = "";

      this.props.handleChange && this.props.handleChange(otpCode.join(""));
      this.setState({ otpCode, error: null });

      if (index > this.minIndex && index <= this.maxIndex) {
        this._focusInput(index - 1);
      }
    }
  };

  _focusInput = (index) => {
    this.inputs[index].input.focus();
  };

  clear = () => {
    this.setState({ otpCode: [] });
    this.inputs.forEach((otpInput) => {
      otpInput.input?.clear();
    });
  };

  _renderInputs = () => {
    const {
      errorMessage,
      focusedBorderColor,
      inputContainerStyles,
      inputStyles,
      inputTextErrorColor,
      numberOfInputs,
      unFocusedBorderColor
    } = this.props;
    const { otpCode, containerWidth } = this.state;
    const fieldWidth = parseInt(containerWidth / 7);
    const inputArray = [];
    for (let index = 0; index < numberOfInputs; index++) {
      inputArray[index] = (
        <OtpInput
          containerStyles={inputContainerStyles}
          error={!!errorMessage}
          focusedBorderColor={focusedBorderColor}
          handleBackspace={(event) => this._handleBackspace(event, index)}
          inputStyles={inputStyles}
          keyIs={index}
          key={index}
          ref={(input) => {
            this.inputs[index] = input;
          }}
          textErrorColor={inputTextErrorColor}
          unFocusedBorderColor={unFocusedBorderColor}
          updateText={(text) => this._updateText(text, index)}
          value={otpCode[index]}
          fieldWidth={fieldWidth}
        />
      );
    }

    return inputArray;
  };

  render() {
    const {
      containerStyles,
      errorMessage,
      errorMessageContainerStyles,
      errorMessageTextStyles
    } = this.props;

    return (
      <View
        style={[defaultStyles.container, containerStyles]}
        onLayout={(event) => {
          const { width } = event.nativeEvent.layout;
          this.setState({ containerWidth: width });
        }}
      >
        {/* {errorMessage && (
          <View
            style={[
              defaultStyles.errorMessageContainer,
              errorMessageContainerStyles
            ]}
          >
            <Text testID="errorText" style={errorMessageTextStyles}>
              {errorMessage}
            </Text>
          </View>
        )} */}
        <View style={defaultStyles.inputsContainer}>
          {this._renderInputs()}
        </View>
      </View>
    );
  }
}

/* eslint-enable */

const defaultStyles = StyleSheet.create({
  container: {
    backgroundColor: "white",
    marginVertical: 8
  },
  inputsContainer: {
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "space-between"
  },
  errorMessageContainer: {
    marginHorizontal: 10
  }
});
